import { render } from "./EditPurchasePage.vue?vue&type=template&id=30db041a&ts=true"
import script from "./EditPurchasePage.vue?vue&type=script&lang=ts"
export * from "./EditPurchasePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__